function hexToRgba(hex, alpha = 0.15) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

const mixWithWhite = (hex, amount = 0.5) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  const nr = Math.round(r + (255 - r) * amount);
  const ng = Math.round(g + (255 - g) * amount);
  const nb = Math.round(b + (255 - b) * amount);

  return `rgb(${nr}, ${ng}, ${nb})`;
};

export default function TimeGridEvent({ calendarEvent, view }) {
  const { bookingId, customerName, phone, service, seats, status, color, dayCount, dayIndex, date } = calendarEvent.data;

  const today = new Date().toISOString().split('T')[0];
  const isPast = date && date < today;

  // const bgAlpha = dayCount >= 2 ? 0.85 : 0.15;
  const bgAlpha = dayCount >= 2 ? 0.15 : 0.15;
  const LIMIT = 3;
  const safeColor = color || '#9CA3AF';
  const stripAlpha = 0.25; // transparent strip

  const isDay = view === 'day';
  const isWeek = view === 'week';

  if (dayCount > LIMIT && dayIndex > LIMIT) return null;

  if (dayCount > LIMIT && dayIndex === LIMIT) {
    const more = dayCount - LIMIT;

    return (
      <div
        onClick={(e) => {
          e.stopPropagation();
          window.location.href = `/booking-management`;
        }}
        title={`+${more} more`}
        style={{
          position: 'absolute',
          right: 2,
          bottom: 2,
          width: 20,
          borderRadius: 6,
          background: '#e5e7eb',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 10,
          fontWeight: 700,
          color: '#111827',
          cursor: 'pointer',
          zIndex: 10
        }}
      >
        +{more}
      </div>
    );
  }
  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        borderRadius: 6,
        overflow: 'hidden',
        // background: hexToRgba(color, 0.15), // transparent fill
        // background: hexToRgba(color, bgAlpha),
        // background: color,
        background: safeColor,
        minWidth: 150,
        maxWidth: isDay ? '' : 170
      }}
    >
      <div
        style={{
          width: 5,
          // background: color,
          // background: hexToRgba(color, bgAlpha),
          background: mixWithWhite(safeColor, 0.6),
          flexShrink: 0
        }}
      />

      <div
        style={{
          padding: 6,
          fontSize: 12,
          // color: '#000',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, overflow: 'hidden' }}>
            <span
              style={{
                fontWeight: 600,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                flexShrink: 1
              }}
            >
              {customerName}
            </span>
            {status === 'completed' && (
              <span
                style={{
                  fontSize: 9,
                  fontWeight: 700,
                  background: 'rgba(25,135,84,0.9)',
                  color: '#fff',
                  borderRadius: 3,
                  padding: '1px 5px',
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                  letterSpacing: 0.3
                }}
              >
                Completed
              </span>
            )}
            {status === 'confirmed' && isPast && (
              <span
                style={{
                  fontSize: 9,
                  fontWeight: 700,
                  background: 'rgba(108,117,125,0.9)',
                  color: '#fff',
                  borderRadius: 3,
                  padding: '1px 5px',
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                  letterSpacing: 0.3
                }}
              >
                No Show
              </span>
            )}
          </div>
          <div
            style={{
              fontSize: 11,
              opacity: 0.85,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            <i className="ph ph-phone"></i> {phone}
          </div>
          <div style={{ fontSize: 11 }}>
            <i className="ph ph-identification-card"></i> {bookingId}
          </div>
          <div style={{ fontSize: 11 }}>
            <i className="ph ph-armchair"></i> {seats}
          </div>
        </div>
      </div>

      {/* BOTTOM: Actions */}
      {/* <div
        style={{
          display: 'flex',
          gap: 6,
          marginTop: 4
        }}
      >
        <button
          style={btnStyle}
          onClick={(e) => {
            e.stopPropagation();
            window.dispatchEvent(
              new CustomEvent('booking-view', {
                detail: calendarEvent.data
              })
            );
          }}
        >
          View
        </button>

        <button
          style={btnStyle}
          onClick={(e) => {
            e.stopPropagation();
            window.dispatchEvent(
              new CustomEvent('booking-menu', {
                detail: calendarEvent.data
              })
            );
          }}
        >
          ⋮
        </button>
      </div> */}
    </div>
  );
}
